const getWidth = (domEl) => {
  if (domEl) {
    return domEl.clientWidth || domEl.offsetWidth;
  }

  return null;
};

export default getWidth;
